import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Drawer,
  List,
  Typography,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Alert,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Autocomplete,
  Tooltip,
  FormControlLabel,
  InputAdornment,
  Checkbox,
  CircularProgress,
  Stepper,
  Step,
  StepLabel,
  StepContent
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { format } from 'date-fns';
import {
  Menu as MenuIcon,
  Person as PersonIcon,
  Description as DescriptionIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Download as DownloadIcon,
  Upload as UploadIcon,
  Assignment as AssignmentIcon,
  CheckCircle as ApproveIcon,
  Cancel as RejectIcon,
  FilterList as FilterIcon,
  AttachMoney as MoneyIcon,
  PauseCircle as PauseIcon,
  Edit as EditIcon,
  Refresh as RefreshIcon,
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  FilterListOff as FilterOffIcon,
  Visibility as VisibilityIcon,
  History,
  NotificationsActive
} from '@mui/icons-material';
import { useAuth0 } from '@auth0/auth0-react';
import { useUser } from '../contexts/UserContext';
import { 
  createSupplier, 
  getSuppliers, 
  deleteSupplier, 
  approveInvoice, 
  rejectInvoice,
  markInvoiceAsPaid,
  getDownloadUrl,
  getAdminTodos,
  deleteTodo,
  createTodo,
  updateTodo,
  updateSupplier,
  getInvoiceAuditLogs,
  getSupplierContractUrl,
  updateTodoAdmin,
  pingTodoSupplier
} from '../services/api';
import BatchSupplierUpload from './BatchSupplierUpload';
import BatchTodoUpload from './BatchTodoUpload';
import axios from 'axios';

const drawerWidth = 240;

// Status options for filtering
const STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: 'pending', label: 'Pending Upload' },
  { value: 'uploaded', label: 'Uploaded' },
  { value: 'approved', label: 'Approved' },
  { value: 'hold', label: 'On Hold' },
  { value: 'paid', label: 'Paid' },
  { value: 'rejected', label: 'Rejected' }
];

// List of countries with their ISO codes for flags
const countries = [
  { code: 'AD', name: 'Andorra' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AG', name: 'Antigua and Barbuda' },
  { code: 'AI', name: 'Anguilla' },
  { code: 'AL', name: 'Albania' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AO', name: 'Angola' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AT', name: 'Austria' },
  { code: 'AU', name: 'Australia' },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'BA', name: 'Bosnia and Herzegovina' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BI', name: 'Burundi' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BN', name: 'Brunei' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BR', name: 'Brazil' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BZ', name: 'Belize' },
  { code: 'CA', name: 'Canada' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CV', name: 'Cape Verde' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'DE', name: 'Germany' },
  { code: 'DK', name: 'Denmark' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EE', name: 'Estonia' },
  { code: 'EG', name: 'Egypt' },
  { code: 'ES', name: 'Spain' },
  { code: 'FI', name: 'Finland' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'FR', name: 'France' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GE', name: 'Georgia' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GR', name: 'Greece' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HR', name: 'Croatia' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HU', name: 'Hungary' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IN', name: 'India' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IR', name: 'Iran' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IT', name: 'Italy' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JO', name: 'Jordan' },
  { code: 'JP', name: 'Japan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'KR', name: 'South Korea' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'LA', name: 'Laos' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LY', name: 'Libya' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MD', name: 'Moldova' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MK', name: 'Macedonia' },
  { code: 'ML', name: 'Mali' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'MT', name: 'Malta' },
  { code: 'MV', name: 'Maldives' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MX', name: 'Mexico' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NO', name: 'Norway' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'OM', name: 'Oman' },
  { code: 'PA', name: 'Panama' },
  { code: 'PE', name: 'Peru' },
  { code: 'PG', name: 'Papua New Guinea' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RO', name: 'Romania' },
  { code: 'RS', name: 'Serbia' },
  { code: 'RU', name: 'Russia' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SE', name: 'Sweden' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SN', name: 'Senegal' },
  { code: 'SO', name: 'Somalia' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TJ', name: 'Tajikistan' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TR', name: 'Turkey' },
  { code: 'TT', name: 'Trinidad and Tobago' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'UG', name: 'Uganda' },
  { code: 'US', name: 'United States' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VA', name: 'Vatican City' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' }
];

// Helper function to render country flag from country code
const getCountryFlag = (countryCode) => {
  // Convert country code to regional indicator symbols (flag emoji)
  return countryCode
    ? countryCode.toUpperCase().replace(/./g, char => 
        String.fromCodePoint(char.charCodeAt(0) + 127397))
    : '';
};

// Helper function to generate month options
const generateMonthOptions = () => {
  const options = [{ value: '', label: 'All Months' }];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  
  // Generate options for current year and previous year
  for (let year = currentYear; year >= currentYear - 1; year--) {
    for (let month = 12; month >= 1; month--) {
      const monthStr = month.toString().padStart(2, '0');
      options.push({
        value: `${monthStr}/${year}`,
        label: `${monthStr}/${year}`
      });
    }
  }
  
  return options;
};

const AdminDashboard = () => {
  const { logout } = useAuth0();
  const [open, setOpen] = useState(true);
  const [view, setView] = useState('todos'); // 'suppliers' or 'todos'
  const [addSupplierOpen, setAddSupplierOpen] = useState(false);
  const [newSupplier, setNewSupplier] = useState({ 
    name: '', 
    email: '', 
    balance: 0,
    street: '',
    city: '',
    state: '',
    country: '',
    iban: '',
    swift_code: '',
    contract_file: null
  });
  const [suppliers, setSuppliers] = useState([]);
  const [todos, setTodos] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [supplierToDelete, setSupplierToDelete] = useState(null);
  const [csvUploadResult, setCsvUploadResult] = useState(null);
  const [csvResultOpen, setCsvResultOpen] = useState(false);
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [todoToDelete, setTodoToDelete] = useState(null);
  const [deleteTaskConfirmOpen, setDeleteTaskConfirmOpen] = useState(false);
  const [addTaskOpen, setAddTaskOpen] = useState(false);
  const [newTask, setNewTask] = useState({
    supplier_name: '',
    month_year: format(new Date(), 'MM/yyyy'),
    title: 'Monthly Invoice',
    description: '',
    originalAmount: '',
    deduction: '',
    amount: '',
    due_date: null
  });
  const [taskDate, setTaskDate] = useState(new Date());
  
  // Filter states
  const [statusFilter, setStatusFilter] = useState('');
  const [monthFilter, setMonthFilter] = useState('');
  const [supplierFilter, setSupplierFilter] = useState('');
  const monthOptions = generateMonthOptions();

  const [editTaskOpen, setEditTaskOpen] = useState(false);
  const [taskToEdit, setTaskToEdit] = useState(null);

  const [editTodo, setEditTodo] = useState(null);
  const [editSupplier, setEditSupplier] = useState(null);

  // Add a file input ref
  const fileInputRef = useRef(null);

  const { currentUser } = useUser();
  const isViewer = currentUser?.is_admin_viewer && !currentUser?.is_admin;

  const [auditDrawerOpen, setAuditDrawerOpen] = useState(false);
  const [auditLogs, setAuditLogs] = useState([]);
  const [auditLoading, setAuditLoading] = useState(false);
  const [selectedAuditTodo, setSelectedAuditTodo] = useState(null);

  const [approveDialogOpen, setApproveDialogOpen] = useState(false);
  const [approveTodo, setApproveTodo] = useState(null);
  const [approveDate, setApproveDate] = useState(null);

  // Add state for ping dialog
  const [pingDialogOpen, setPingDialogOpen] = useState(false);
  const [pingMessage, setPingMessage] = useState('');
  const [pingTodo, setPingTodo] = useState(null);

  const [supplierSearch, setSupplierSearch] = useState('');
  const [batchUploadOpen, setBatchUploadOpen] = useState(false);
  const [batchTodoOpen, setBatchTodoOpen] = useState(false);

  useEffect(() => {
    if (view === 'suppliers') {
      fetchSuppliers();
    } else {
      fetchTodos();
    }
  }, [view, statusFilter, monthFilter, supplierFilter]);

  useEffect(() => {
    if (editTodo) {
      setTaskToEdit({
        ...editTodo,
        originalAmount: editTodo.amount, // amount is already the original amount
        deduction: editTodo.deduction || 0,
        finalAmount: editTodo.total_after_deduction || (editTodo.amount - (editTodo.deduction || 0))
      });
      setEditTaskOpen(true);
    }
  }, [editTodo]);

  useEffect(() => {
    if (editSupplier) {
      setNewSupplier({
        ...newSupplier,
        name: editSupplier.name,
        email: editSupplier.email,
        balance: editSupplier.balance,
        street: editSupplier.street,
        city: editSupplier.city,
        state: editSupplier.state,
        country: editSupplier.country,
        iban: editSupplier.iban,
        swift_code: editSupplier.swift_code
      });
      setAddSupplierOpen(true);
    }
  }, [editSupplier]);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleAddSupplier = async () => {
    try {
      // Create a FormData object to handle the file upload
      const formData = new FormData();
      
      // Add all the supplier fields to the FormData
      formData.append('name', newSupplier.name);
      formData.append('email', newSupplier.email);
      formData.append('balance', parseFloat(newSupplier.balance) || 0);
      if (newSupplier.street) formData.append('street', newSupplier.street);
      if (newSupplier.city) formData.append('city', newSupplier.city);
      if (newSupplier.state) formData.append('state', newSupplier.state);
      if (newSupplier.country) formData.append('country', newSupplier.country);
      if (newSupplier.iban) formData.append('iban', newSupplier.iban);
      if (newSupplier.swift_code) formData.append('swift_code', newSupplier.swift_code);
      
      // Append the contract file if it exists
      if (newSupplier.contract_file) {
        formData.append('contract_file', newSupplier.contract_file);
      }
      
      if (editSupplier) {
        // For editing, use FormData and the updated updateSupplier function to support file upload
        await updateSupplier(
          editSupplier.name,
          editSupplier.email,
          formData
        );
        setSnackbar({ open: true, message: 'Supplier updated successfully', severity: 'success' });
      } else {
        // For creating, we'll use a direct axios call to support the file upload
        await axios.post(
          `${process.env.REACT_APP_API_URL || 'http://localhost:8000/api/'}suppliers`, 
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
          }
        );
        setSnackbar({ open: true, message: 'Supplier created successfully', severity: 'success' });
      }
      
      fetchSuppliers();
      setAddSupplierOpen(false);
      setNewSupplier({ 
        name: '', 
        email: '', 
        balance: 0,
        street: '',
        city: '',
        state: '',
        country: '',
        iban: '',
        swift_code: '',
        contract_file: null,
        contract_file_path: null
      });
      setEditSupplier(null); // Reset editSupplier after add/edit
      // Reset the file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      setSnackbar({ open: true, message: error.message || 'Failed to create supplier', severity: 'error' });
    }
  };

  const fetchSuppliers = async () => {
    try {
      const response = await getSuppliers();
      setSuppliers(response.data);
    } catch (error) {
      setSnackbar({ open: true, message: 'Failed to fetch suppliers', severity: 'error' });
    }
  };

  const fetchTodos = async () => {
    try {
      const response = await getAdminTodos({ 
        status: statusFilter,
        monthYear: monthFilter,
        supplierName: supplierFilter
      });
      setTodos(response.data);
    } catch (error) {
      console.error('Error fetching todos:', error);
      setSnackbar({ open: true, message: 'Failed to fetch todos', severity: 'error' });
    }
  };

  const handleDeleteClick = (supplier) => {
    setSupplierToDelete(supplier);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const result = await deleteSupplier(supplierToDelete.name, supplierToDelete.email);
      setSnackbar({ open: true, message: result.message || 'Supplier deleted successfully', severity: 'success' });
      fetchSuppliers();
    } catch (error) {
      setSnackbar({ open: true, message: error.message || 'Failed to delete supplier', severity: 'error' });
    } finally {
      setDeleteConfirmOpen(false);
      setSupplierToDelete(null);
    }
  };

  const handleDownload = async (supplierName, monthYear) => {
    try {
      const response = await getDownloadUrl(supplierName, monthYear);
      window.open(response.data.download_url, '_blank');
    } catch (error) {
      console.error('Error getting download URL:', error);
      setSnackbar({ open: true, message: 'Failed to download file', severity: 'error' });
    }
  };

  const handleApprove = async (supplierName, monthYear) => {
    try {
      await approveInvoice(supplierName, monthYear);
      setSnackbar({ open: true, message: 'Invoice approved successfully', severity: 'success' });
      fetchTodos();
    } catch (error) {
      console.error('Error approving invoice:', error);
      setSnackbar({ open: true, message: 'Failed to approve invoice', severity: 'error' });
    }
  };

  const handleRejectClick = (todo) => {
    setSelectedInvoice({
      supplierName: todo.supplier_name,
      monthYear: todo.month_year
    });
    setRejectionReason('');
    setRejectDialogOpen(true);
  };

  const handleRejectConfirm = async () => {
    try {
      await rejectInvoice(
        selectedInvoice.supplierName, 
        selectedInvoice.monthYear,
        rejectionReason || 'Invoice rejected'
      );
      setSnackbar({ open: true, message: 'Invoice rejected successfully', severity: 'success' });
      fetchTodos();
    } catch (error) {
      console.error('Error rejecting invoice:', error);
      setSnackbar({ open: true, message: 'Failed to reject invoice', severity: 'error' });
    } finally {
      setRejectDialogOpen(false);
      setSelectedInvoice(null);
    }
  };

  const handleCsvUpload = async (event) => {
    const file = event.target.files[0];
    if (!file || !file.name.endsWith('.csv')) {
      setSnackbar({ open: true, message: 'Please select a valid CSV file', severity: 'error' });
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || 'http://localhost:8000/api'}/todos/upload-csv`, 
        formData, 
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
          }
        }
      );
      
      setCsvUploadResult(response.data);
      setCsvResultOpen(true);
      
      if (response.data.tasks_created > 0) {
        setSnackbar({ open: true, message: `Successfully created ${response.data.tasks_created} tasks`, severity: 'success' });
      } else {
        setSnackbar({ open: true, message: 'No tasks were created from the CSV', severity: 'warning' });
      }
    } catch (error) {
      console.error('Error uploading CSV:', error);
      setSnackbar({ open: true, message: error.response?.data?.detail || 'Failed to upload CSV', severity: 'error' });
    }
    
    // Clear the file input
    event.target.value = null;
  };

  const handleMarkAsPaid = async (supplierName, monthYear) => {
    try {
      await markInvoiceAsPaid(supplierName, monthYear);
      setSnackbar({ open: true, message: 'Invoice marked as paid successfully', severity: 'success' });
      fetchTodos();
    } catch (error) {
      console.error('Error marking invoice as paid:', error);
      setSnackbar({ open: true, message: 'Failed to mark invoice as paid', severity: 'error' });
    }
  };

  const handleSetOnHold = async (supplierName, monthYear) => {
    try {
      const [month, year] = monthYear.split('/');
      const paddedMonth = month.padStart(2, '0');
      const normalizedMonthYear = `${paddedMonth}-${year}`;
      await updateTodoAdmin(supplierName, normalizedMonthYear, { status: 'hold' });
      setSnackbar({ open: true, message: 'Invoice set to On Hold', severity: 'success' });
      fetchTodos();
    } catch (error) {
      console.error('Error setting invoice on hold:', error);
      setSnackbar({ open: true, message: 'Failed to set invoice on hold', severity: 'error' });
    }
  };

  const getStatusChip = (todo) => {
    if (!todo.file_key) {
      return <Chip label="Pending Upload" color="warning" size="small" />;
    }
    
    switch (todo.status) {
      case 'approved':
        return <Chip label="Approved" color="success" size="small" />;
      case 'hold':
        return <Chip label="On Hold" color="warning" size="small" />;
      case 'paid':
        return <Chip label="Paid" color="success" size="small" sx={{ bgcolor: '#7b1fa2' }} />;
      case 'rejected':
        return <Chip label="Rejected" color="error" size="small" />;
      case 'uploaded':
      default:
        return <Chip label="Uploaded" color="info" size="small" />;
    }
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const resetFilters = () => {
    setStatusFilter('');
    setMonthFilter('');
    setSupplierFilter('');
  };

  const handleDeleteTaskClick = (todo) => {
    setTodoToDelete(todo);
    setDeleteTaskConfirmOpen(true);
  };

  const handleDeleteTaskConfirm = async () => {
    try {
      await deleteTodo(todoToDelete.supplier_name, todoToDelete.month_year);
      setSnackbar({ open: true, message: 'Task deleted successfully', severity: 'success' });
      fetchTodos();
    } catch (error) {
      console.error('Error deleting task:', error);
      setSnackbar({ open: true, message: 'Failed to delete task', severity: 'error' });
    } finally {
      setDeleteTaskConfirmOpen(false);
      setTodoToDelete(null);
    }
  };

  const handleAddTaskOpen = () => {
    // Make sure suppliers are loaded before opening the dialog
    fetchSuppliers();
    // Set a default description
    setNewTask({
      ...newTask,
      description: `Please upload an invoice for ${format(new Date(), 'MM/yyyy')}.`
    });
    setAddTaskOpen(true);
  };

  const handleAddTask = async () => {
    try {
      // Find the selected supplier to get their email
      const selectedSupplier = suppliers.find(sup => sup.name === newTask.supplier_name);
      
      if (!selectedSupplier) {
        setSnackbar({ open: true, message: 'Please select a valid supplier', severity: 'error' });
        return;
      }
      
      const originalAmount = parseFloat(newTask.originalAmount) || 0;
      const deduction = parseFloat(newTask.deduction) || 0;
      
      await createTodo({
        ...newTask,
        user_email: selectedSupplier.email, // Use the supplier's email
        amount: originalAmount, // Send the original amount, not the final amount
        deduction: newTask.deduction ? parseFloat(newTask.deduction) : null
      });
      setAddTaskOpen(false);
      setNewTask({
        supplier_name: '',
        month_year: format(new Date(), 'MM/yyyy'),
        title: 'Monthly Invoice',
        description: '',
        originalAmount: '',
        deduction: '',
        amount: '',
        due_date: null
      });
      setTaskDate(new Date());
      setSnackbar({ open: true, message: 'Task created successfully', severity: 'success' });
      fetchTodos();
    } catch (error) {
      console.error('Error creating task:', error);
      setSnackbar({ open: true, message: error.message || 'Failed to create task', severity: 'error' });
    }
  };

  const handleDateChange = (newDate) => {
    setTaskDate(newDate);
    // Update the month in both month_year and the description
    const formattedMonth = format(newDate, 'MM/yyyy');
    setNewTask({
      ...newTask,
      month_year: formattedMonth,
      description: `Please upload an invoice for ${formattedMonth}.`
    });
  };

  const handleEditTaskClick = (todo) => {
    setTaskToEdit({
      ...todo,
      due_date: todo.due_date ? new Date(todo.due_date) : null
    });
    setEditTaskOpen(true);
  };

  const handleEditTaskSubmit = async () => {
    try {
      // Calculate the original amount from the displayed final amount and deduction
      const displayedAmount = parseFloat(taskToEdit.amount) || 0;
      const deduction = parseFloat(taskToEdit.deduction) || 0;
      const originalAmount = displayedAmount + deduction; // Reverse the calculation
      
      await updateTodo(
        taskToEdit.id,
        taskToEdit.supplier_name,
        taskToEdit.month_year,
        taskToEdit.title,
        taskToEdit.description,
        originalAmount, // Send the original amount, not the final amount
        deduction,
        taskToEdit.status,
        taskToEdit.completed,
        taskToEdit.due_date,
        taskToEdit.rejection_reason
      );
      setSnackbar({ open: true, message: 'Task updated successfully', severity: 'success' });
      fetchTodos();
    } catch (error) {
      console.error('Error updating task:', error);
      setSnackbar({ open: true, message: 'Failed to update task', severity: 'error' });
    } finally {
      setEditTaskOpen(false);
      setTaskToEdit(null);
    }
  };

  const handleEditTodo = (todo) => {
    setEditTodo({
      ...todo,
      originalAmount: todo.amount, // amount is already the original amount
      deduction: todo.deduction || 0,
      finalAmount: todo.total_after_deduction || (todo.amount - (todo.deduction || 0))
    });
    setEditTaskOpen(true);
  };

  const handleEditSupplier = (supplier) => {
    setEditSupplier(supplier);
    setAddSupplierOpen(true);
  };

  // Add a function to handle contract file selection
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setNewSupplier({
        ...newSupplier,
        contract_file: e.target.files[0],
        contract_file_name: e.target.files[0].name
      });
    }
  };

  // Add function to view supplier contract
  const handleViewContract = async (supplier) => {
    if (!supplier.contract_file) {
      setSnackbar({ open: true, message: 'No contract file available', severity: 'info' });
      return;
    }
    try {
      const response = await getSupplierContractUrl(supplier.name, supplier.email);
      if (response.data && response.data.download_url) {
        window.open(response.data.download_url, '_blank', 'noopener,noreferrer');
      } else {
        setSnackbar({ open: true, message: 'No contract URL found', severity: 'error' });
      }
    } catch (error) {
      console.error('Error getting contract URL:', error);
      setSnackbar({ open: true, message: 'Failed to retrieve contract file', severity: 'error' });
    }
  };

  const handleOpenAuditDrawer = async (todo) => {
    setSelectedAuditTodo(todo);
    setAuditDrawerOpen(true);
    setAuditLoading(true);
    try {
      const res = await getInvoiceAuditLogs(todo.supplier_name, todo.month_year);
      setAuditLogs(res.data);
    } catch (err) {
      setAuditLogs([]);
    } finally {
      setAuditLoading(false);
    }
  };

  const handleCloseAuditDrawer = () => {
    setAuditDrawerOpen(false);
    setAuditLogs([]);
    setSelectedAuditTodo(null);
  };

  const handleOpenPingDialog = (todo) => {
    setPingTodo(todo);
    setPingMessage(`This is a reminder regarding your pending todo: ${todo.title}`);
    setPingDialogOpen(true);
  };

  const handleClosePingDialog = () => {
    setPingDialogOpen(false);
    setPingTodo(null);
    setPingMessage('');
  };

  const handleSendPing = async () => {
    try {
      await pingTodoSupplier(pingTodo.supplier_name, pingTodo.month_year, pingMessage);
      showSnackbar('Reminder email sent successfully', 'success');
      handleClosePingDialog();
    } catch (err) {
      showSnackbar('Failed to send reminder email', 'error');
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>

      <Drawer
        variant="persistent"
        anchor="left"
        open={open}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            boxShadow: '2px 0 10px rgba(0,0,0,0.05)',
            border: 'none',
            backgroundColor: '#fff',
            borderRight: '1px solid #f0f0f0'
          },
        }}
      >
        <Box sx={{ 
          overflow: 'auto', 
          mt: 2,
          px: 1,
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
            <img src="logo192.png" alt="Logo" style={{ height: 56, marginBottom: 16, marginTop: 8 }} />
          </Box>
          <List sx={{ width: '100%' }}>
            <ListItem 
              button 
              onClick={() => { setView('suppliers'); resetFilters(); }}
              sx={{ 
                borderRadius: '12px', 
                mb: 1,
                py: 1.5,
                bgcolor: view === 'suppliers' ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                color: view === 'suppliers' ? 'primary.main' : 'text.primary',
                '&:hover': {
                  bgcolor: view === 'suppliers' ? 'rgba(25, 118, 210, 0.12)' : 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              <ListItemIcon 
                sx={{ 
                  color: view === 'suppliers' ? 'primary.main' : 'text.secondary',
                  minWidth: '40px'
                }}
              >
                <PersonIcon />
              </ListItemIcon>
              <ListItemText 
                primary="Suppliers" 
                primaryTypographyProps={{ 
                  fontWeight: view === 'suppliers' ? 600 : 500,
                  fontSize: '0.95rem'
                }}
              />
              {view === 'suppliers' && (
                <Box
                  sx={{
                    width: 4,
                    height: 32,
                    bgcolor: 'primary.main',
                    borderRadius: '4px',
                    position: 'absolute',
                    left: 0
                  }}
                />
              )}
            </ListItem>
            <ListItem 
              button 
              onClick={() => { setView('todos'); resetFilters(); }}
              sx={{ 
                borderRadius: '12px', 
                py: 1.5,
                bgcolor: view === 'todos' ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                color: view === 'todos' ? 'primary.main' : 'text.primary',
                '&:hover': {
                  bgcolor: view === 'todos' ? 'rgba(25, 118, 210, 0.12)' : 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              <ListItemIcon 
                sx={{ 
                  color: view === 'todos' ? 'primary.main' : 'text.secondary',
                  minWidth: '40px'
                }}
              >
                <AssignmentIcon />
              </ListItemIcon>
              <ListItemText 
                primary="Tasks & Invoices" 
                primaryTypographyProps={{ 
                  fontWeight: view === 'todos' ? 600 : 500,
                  fontSize: '0.95rem'
                }}
              />
              {view === 'todos' && (
                <Box
                  sx={{
                    width: 4,
                    height: 32,
                    bgcolor: 'primary.main',
                    borderRadius: '4px',
                    position: 'absolute',
                    left: 0
                  }}
                />
              )}
            </ListItem>
          </List>
        </Box>
      </Drawer>

      <Box component="main" sx={{ width: '100%', marginLeft: '-150px', display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 6 }}>
        {view === 'suppliers' ? (
          <Container>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              mb: 4,
              mt: 2 
            }}>
              <Typography variant="h4" sx={{ fontWeight: 700, fontSize: '2rem', color: 'primary.main', mb: 2 }}>Suppliers</Typography>
              <Box>
                <Button 
                  variant="outlined" 
                  onClick={fetchSuppliers}
                  startIcon={<RefreshIcon />} 
                  sx={{ mr: 2, textTransform: 'none', borderRadius: '8px', fontWeight: 500 }}
                >
                  Refresh
                </Button>
                <Tooltip title={isViewer ? "You're in viewer mode" : "Batch Upload Suppliers"}>
                  <span>
                    <Button
                      variant="outlined"
                      onClick={() => setBatchUploadOpen(true)}
                      startIcon={<UploadIcon />}
                      disabled={isViewer}
                      sx={{ mr: 2, textTransform: 'none', borderRadius: '8px', fontWeight: 500 }}
                    >
                      Batch Upload
                    </Button>
                  </span>
                </Tooltip>
                <Tooltip title={isViewer ? "You're in viewer mode" : "Add Supplier"}>
                  <span>
                    <Button
                      variant="contained"
                      onClick={() => setAddSupplierOpen(true)}
                      startIcon={<AddIcon />}
                      disabled={isViewer}
                      sx={{ textTransform: 'none', borderRadius: '8px', fontWeight: 500 }}
                    >
                      Add supplier
                    </Button>
                  </span>
                </Tooltip>
              </Box>
            </Box>
            {/* Supplier search input */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
              <TextField
                label="Search suppliers"
                variant="outlined"
                size="small"
                value={supplierSearch}
                onChange={e => setSupplierSearch(e.target.value)}
                sx={{ width: 400 }}
                placeholder="Search by name or email"
              />
            </Box>
            <Paper 
              elevation={2}
              sx={{ boxShadow: '0 2px 16px rgba(0,0,0,0.04)', borderRadius: '16px', p: 2 }}
            >
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Name</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Email</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc', minWidth: 220, whiteSpace: 'normal', wordBreak: 'break-word' }}>Address</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc', minWidth: 220, whiteSpace: 'normal', wordBreak: 'break-word' }}>Banking</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(() => {
                      const filteredSuppliers = suppliers.filter(supplier =>
                        supplier.name.toLowerCase().includes(supplierSearch.toLowerCase()) ||
                        supplier.email.toLowerCase().includes(supplierSearch.toLowerCase())
                      );
                      return filteredSuppliers.length > 0 ? filteredSuppliers.map((supplier) => (
                        <TableRow 
                          key={supplier.email}
                          hover
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell sx={{ py: 2 }}>{supplier.name}</TableCell>
                          <TableCell sx={{ py: 2 }}>{supplier.email}</TableCell>
                          <TableCell sx={{ py: 2, minWidth: 220, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {supplier.city && supplier.country ? (
                              `${supplier.city}, ${supplier.country}`
                            ) : (
                              <Typography color="text.secondary" variant="body2">Not provided</Typography>
                            )}
                          </TableCell>
                          <TableCell sx={{ py: 2, minWidth: 220, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {supplier.iban ? (
                              <Box>
                                <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                  IBAN: {supplier.iban}
                                </Typography>
                                <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                  SWIFT: {supplier.swift_code || 'Not provided'}
                                </Typography>
                              </Box>
                            ) : (
                              <Typography color="text.secondary" variant="body2">Not provided</Typography>
                            )}
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              {supplier.contract_file && (
                                <IconButton 
                                  color="primary" 
                                  onClick={() => handleViewContract(supplier)}
                                  size="small"
                                  title="View Contract"
                                  sx={{ 
                                    bgcolor: 'rgba(25, 118, 210, 0.1)', 
                                    '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.2)' } 
                                  }}
                                >
                                  <VisibilityIcon fontSize="small" />
                                </IconButton>
                              )}
                              <Tooltip title={isViewer ? "You're in viewer mode" : "Edit Supplier"}>
                                <span>
                                  <IconButton 
                                    color="primary" 
                                    onClick={() => handleEditSupplier(supplier)}
                                    size="small"
                                    title="Edit Supplier"
                                    disabled={isViewer}
                                    sx={{ 
                                      bgcolor: 'rgba(25, 118, 210, 0.1)', 
                                      '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.2)' } 
                                    }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <IconButton 
                                color="error" 
                                onClick={() => handleDeleteClick(supplier)}
                                size="small"
                                title="Delete Supplier"
                                sx={{ 
                                  bgcolor: 'rgba(211, 47, 47, 0.1)', 
                                  '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.2)' } 
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      )) : (
                        <TableRow>
                          <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                            <Typography color="text.secondary">No suppliers found</Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })()}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Container>
        ) : (
          <Container>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 4
            }}>
              <Typography variant="h4" sx={{ fontWeight: 700, fontSize: '2rem', color: 'primary.main', mb: 2 }}>Tasks & Invoices</Typography>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Tooltip title={isViewer ? "You're in viewer mode" : "Add Task"}>
                  <span>
                    <Button
                      variant="contained"
                      onClick={() => setAddTaskOpen(true)}
                      startIcon={<AddIcon />}
                      disabled={isViewer}
                      sx={{ textTransform: 'none', borderRadius: '8px', fontWeight: 500 }}
                    >
                      Add task
                    </Button>
                  </span>
                </Tooltip>
                <Tooltip title={isViewer ? "You're in viewer mode" : "Batch Upload Tasks"}>
                  <span>
                    <Button
                      component="span"
                      variant="outlined"
                      startIcon={<UploadIcon />}
                      onClick={() => setBatchTodoOpen(true)}
                      disabled={isViewer}
                      sx={{ borderRadius: '8px', color: '#1976d2', borderColor: '#1976d2', textTransform: 'none', fontWeight: 500 }}
                    >
                      Batch Upload tasks
                    </Button>
                  </span>
                </Tooltip>
                <input
                  accept=".csv"
                  id="csv-upload"
                  type="file"
                  onChange={handleCsvUpload}
                  style={{ display: 'none' }}
                />
                
              </Box>
            </Box>
            
            {/* Filters - Complete rewrite to match screenshot */}
            <Paper 
              elevation={2}
              sx={{ boxShadow: '0 2px 16px rgba(0,0,0,0.04)', borderRadius: '16px', p: 4, maxWidth: 1600, width: '100%', mx: 'auto', mb: 4 }}
            >
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 200 }}>
                  <Typography variant="body1" sx={{ mb: 1 }}>Status</Typography>
                  <TextField
                    select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    variant="outlined"
                    fullWidth
                    SelectProps={{
                      IconComponent: () => <Box component="span" sx={{ position: 'absolute', right: 10 }}>▼</Box>,
                    }}
                  >
                    {STATUS_OPTIONS.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
                
                <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 200 }}>
                  <Typography variant="body1" sx={{ mb: 1 }}>Month</Typography>
                  <TextField
                    select
                    value={monthFilter}
                    onChange={(e) => setMonthFilter(e.target.value)}
                    variant="outlined"
                    fullWidth
                    SelectProps={{
                      IconComponent: () => <Box component="span" sx={{ position: 'absolute', right: 10 }}>▼</Box>,
                    }}
                  >
                    {monthOptions.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
                
                <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 200 }}>
                  <Typography variant="body1" sx={{ mb: 1 }}>Supplier</Typography>
                  <TextField
                    select
                    value={supplierFilter}
                    onChange={(e) => setSupplierFilter(e.target.value)}
                    variant="outlined"
                    fullWidth
                    SelectProps={{
                      IconComponent: () => <Box component="span" sx={{ position: 'absolute', right: 10 }}>▼</Box>,
                    }}
                  >
                    <MenuItem value="">All Suppliers</MenuItem>
                    {suppliers.map(supplier => (
                      <MenuItem key={supplier.name} value={supplier.name}>
                        {supplier.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
                
                <Button 
                  variant="outlined" 
                  onClick={resetFilters}
                  startIcon={<FilterIcon />} 
                  sx={{ height: 56, borderRadius: '8px', color: '#1976d2', borderColor: '#1976d2', textTransform: 'none', fontWeight: 500 }}
                >
                  Reset filters
                </Button>
                
                <Button 
                  variant="outlined" 
                  onClick={() => { fetchTodos(); fetchSuppliers(); }}
                  startIcon={<RefreshIcon />} 
                  sx={{ height: 56, borderRadius: '8px', color: '#1976d2', borderColor: '#1976d2', textTransform: 'none', fontWeight: 500 }}
                >
                  Refresh
                </Button>
              </Box>
            </Paper>

            <Paper 
              elevation={2}
              sx={{ boxShadow: '0 2px 16px rgba(0,0,0,0.04)', borderRadius: '16px', p: 4, maxWidth: 1600, width: '100%', mx: 'auto', mb: 4 }}
            >
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Supplier</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Month</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Title</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Original Amount</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Deduction</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Final Amount</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Invoice</TableCell>
                      <TableCell sx={{ fontWeight: 600, textTransform: 'none', fontSize: '1rem', bgcolor: '#f8fafc' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {todos.map((todo) => (
                      <TableRow 
                        key={`${todo.supplier_name}-${todo.month_year}`}
                        hover
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell>{todo.supplier_name}</TableCell>
                        <TableCell>{todo.month_year}</TableCell>
                        <TableCell>{todo.title}</TableCell>
                        <TableCell>
                          {todo.amount !== null ? 
                            `$${todo.amount.toFixed(2)}` : 'N/A'}
                        </TableCell>
                        <TableCell>
                          {todo.deduction > 0 ? `$${todo.deduction.toFixed(2)}` : '$0.00'}
                        </TableCell>
                        <TableCell>
                          {todo.total_after_deduction !== null ? `$${todo.total_after_deduction.toFixed(2)}` : 'N/A'}
                        </TableCell>
                        <TableCell>
                          {todo.status === 'rejected' ? (
                            <Tooltip 
                              title={
                                <Typography variant="body2">
                                  Rejection reason: {todo.rejection_reason || 'No reason provided'}
                                </Typography>
                              }
                              arrow
                              placement="top"
                            >
                              {getStatusChip(todo)}
                            </Tooltip>
                          ) : (
                            getStatusChip(todo)
                          )}
                        </TableCell>
                        <TableCell sx={{ py: 2 }}>
                          {todo.file_name || (
                            <Typography color="text.secondary" variant="body2">
                              No invoice uploaded
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Box sx={{ display: 'flex', gap: 0.5 }}>
                            <Tooltip title={isViewer ? "You're in viewer mode" : "Edit Task"}>
                              <span>
                                <IconButton
                                  color="primary"
                                  onClick={() => handleEditTodo(todo)}
                                  title="Edit Task"
                                  size="small"
                                  disabled={isViewer}
                                  sx={{
                                    bgcolor: 'rgba(25, 118, 210, 0.1)',
                                    '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.2)' }
                                  }}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                            
                            {todo.file_key && (
                              <>
                                <IconButton 
                                  color="primary" 
                                  onClick={() => handleDownload(todo.supplier_name, todo.month_year)}
                                  title="Download"
                                  size="small"
                                  sx={{ 
                                    bgcolor: 'rgba(25, 118, 210, 0.1)', 
                                    '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.2)' }
                                  }}
                                >
                                  <DownloadIcon fontSize="small" />
                                </IconButton>
                                
                                {todo.status === 'uploaded' && (
                                  <>
                                    <IconButton 
                                      color="warning" 
                                      onClick={() => handleSetOnHold(todo.supplier_name, todo.month_year)}
                                      title="Set On Hold"
                                      size="small"
                                      sx={{ 
                                        bgcolor: 'rgba(245, 124, 0, 0.1)', 
                                        '&:hover': { bgcolor: 'rgba(245, 124, 0, 0.2)' }
                                      }}
                                    >
                                      <PauseIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton 
                                      color="success" 
                                      onClick={() => {
                                        setApproveTodo(todo);
                                        setApproveDate(null);
                                        setApproveDialogOpen(true);
                                      }}
                                      title="Approve"
                                      size="small"
                                      sx={{ 
                                        bgcolor: 'rgba(76, 175, 80, 0.1)', 
                                        '&:hover': { bgcolor: 'rgba(76, 175, 80, 0.2)' }
                                      }}
                                    >
                                      <ApproveIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton 
                                      color="error" 
                                      onClick={() => handleRejectClick(todo)}
                                      title="Reject"
                                      size="small"
                                      sx={{ 
                                        bgcolor: 'rgba(211, 47, 47, 0.1)', 
                                        '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.2)' }
                                      }}
                                    >
                                      <RejectIcon fontSize="small" />
                                    </IconButton>
                                  </>
                                )}
                                
                                {todo.status === 'approved' && (
                                  <IconButton 
                                    color="secondary" 
                                    onClick={() => handleMarkAsPaid(todo.supplier_name, todo.month_year)}
                                    title="Mark as Paid"
                                    size="small"
                                    sx={{ 
                                      bgcolor: 'rgba(123, 31, 162, 0.1)', 
                                      '&:hover': { bgcolor: 'rgba(123, 31, 162, 0.2)' }
                                    }}
                                  >
                                    <MoneyIcon fontSize="small" />
                                  </IconButton>
                                )}
                                {todo.status === 'approved' && (
                                  <IconButton 
                                    color="warning" 
                                    onClick={() => handleSetOnHold(todo.supplier_name, todo.month_year)}
                                    title="Set On Hold"
                                    size="small"
                                    sx={{ 
                                      bgcolor: 'rgba(245, 124, 0, 0.1)', 
                                      '&:hover': { bgcolor: 'rgba(245, 124, 0, 0.2)' }
                                    }}
                                  >
                                    <PauseIcon fontSize="small" />
                                  </IconButton>
                                )}
                              </>
                            )}
                            <IconButton 
                              color="error" 
                              onClick={() => handleDeleteTaskClick(todo)}
                              title="Delete Task"
                              size="small"
                              sx={{ 
                                bgcolor: 'rgba(211, 47, 47, 0.1)', 
                                '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.2)' }
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                            <Tooltip title="View Audit Log">
                              <IconButton
                                color="info"
                                onClick={() => handleOpenAuditDrawer(todo)}
                                size="small"
                                sx={{ bgcolor: 'rgba(2, 136, 209, 0.1)', '&:hover': { bgcolor: 'rgba(2, 136, 209, 0.2)' } }}
                              >
                                <History fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <IconButton
                              size="small"
                              onClick={() => handleOpenPingDialog(todo)}
                              title="Send Reminder (Ping)"
                              sx={{ ml: 1 }}
                            >
                              <NotificationsActive fontSize="small" />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                    {todos.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                          <Typography color="text.secondary">
                            No tasks found matching the filters
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Container>
        )}
      </Box>

      {/* Add Supplier Dialog */}
      <Dialog 
        open={addSupplierOpen} 
        onClose={() => {
          setAddSupplierOpen(false);
          setEditSupplier(null); // Reset editSupplier when closing dialog
        }}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
          }
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          fontSize: '1.5rem', 
          fontWeight: 600,
          borderBottom: '1px solid #f0f0f0',
          pb: 2
        }}>
          Add New Supplier
        </DialogTitle>
        <form onSubmit={(e) => {
          e.preventDefault();
          handleAddSupplier();
        }}>
          <DialogContent sx={{ pt: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                autoFocus
                label="Name"
                fullWidth
                variant="outlined"
                value={newSupplier.name}
                onChange={(e) => setNewSupplier({...newSupplier, name: e.target.value})}
                required
              />
              <TextField
                label="Email"
                type="email"
                fullWidth
                variant="outlined"
                value={newSupplier.email}
                onChange={(e) => setNewSupplier({...newSupplier, email: e.target.value})}
                required
              />
              <TextField
                label="Initial Balance"
                type="number"
                fullWidth
                variant="outlined"
                value={newSupplier.balance}
                onChange={(e) => setNewSupplier({...newSupplier, balance: e.target.value})}
              />
              
              <Typography variant="subtitle1" sx={{ mt: 1, fontWeight: 600 }}>Address Information</Typography>
              
              <TextField
                label="Street"
                fullWidth
                variant="outlined"
                value={newSupplier.street}
                onChange={(e) => setNewSupplier({...newSupplier, street: e.target.value})}
              />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="City"
                    fullWidth
                    variant="outlined"
                    value={newSupplier.city}
                    onChange={(e) => setNewSupplier({...newSupplier, city: e.target.value})}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="State"
                    fullWidth
                    variant="outlined"
                    value={newSupplier.state}
                    onChange={(e) => setNewSupplier({...newSupplier, state: e.target.value})}
                  />
                </Grid>
              </Grid>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="country-select-label">Country</InputLabel>
                <Select
                  labelId="country-select-label"
                  id="country-select"
                  value={newSupplier.country}
                  onChange={(e) => setNewSupplier({...newSupplier, country: e.target.value})}
                  label="Country"
                >
                  {countries.map((country) => (
                    <MenuItem key={country.code} value={country.name}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ mr: 1, fontSize: '1.2rem' }}>
                          {getCountryFlag(country.code)}
                        </Typography>
                        {country.name}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              
              <Typography variant="subtitle1" sx={{ mt: 1, fontWeight: 600 }}>Banking Information</Typography>
              
              <TextField
                label="IBAN"
                fullWidth
                variant="outlined"
                value={newSupplier.iban}
                onChange={(e) => setNewSupplier({...newSupplier, iban: e.target.value})}
              />
              <TextField
                label="SWIFT Code"
                fullWidth
                variant="outlined"
                value={newSupplier.swift_code}
                onChange={(e) => setNewSupplier({...newSupplier, swift_code: e.target.value})}
              />
              
              <Typography variant="subtitle1" sx={{ mt: 1, fontWeight: 600 }}>Contract</Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <input
                  accept=".pdf,.doc,.docx"
                  type="file"
                  id="contract-file-upload"
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />
                <label htmlFor="contract-file-upload">
                  <Button
                    variant="outlined"
                    component="span"
                    startIcon={<UploadIcon />}
                    sx={{ mr: 2 }}
                  >
                    Upload Contract
                  </Button>
                </label>
                {newSupplier.contract_file_name && (
                  <Typography variant="body2">
                    {newSupplier.contract_file_name}
                  </Typography>
                )}
                {newSupplier.contract_file_path && !newSupplier.contract_file && (
                  <Typography variant="body2">
                    Contract already uploaded
                  </Typography>
                )}
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #f0f0f0' }}>
            <Button 
              onClick={() => {
                setAddSupplierOpen(false);
                setEditSupplier(null); // Reset editSupplier when clicking Cancel
              }}
              variant="outlined"
              sx={{ borderRadius: '8px', textTransform: 'none' }}
            >
              Cancel
            </Button>
            <Button 
              type="submit"
              variant="contained"
              disabled={isViewer || !newSupplier.name || !newSupplier.email}
              sx={{ 
                borderRadius: '8px', 
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
              }}
            >
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog 
        open={deleteConfirmOpen} 
        onClose={() => setDeleteConfirmOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
          }
        }}
        maxWidth="sm"
      >
        <DialogTitle sx={{ 
          fontSize: '1.5rem', 
          fontWeight: 600,
          borderBottom: '1px solid #f0f0f0',
          pb: 2,
          color: '#d32f2f'
        }}>
          Confirm Delete
        </DialogTitle>
        <form onSubmit={(e) => {
          e.preventDefault();
          handleDeleteConfirm();
        }}>
          <DialogContent sx={{ pt: 3 }}>
            <Typography variant="body1">
              Are you sure you want to delete supplier <strong>{supplierToDelete?.name}</strong>?
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              This action cannot be undone. All associated data will be permanently removed.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #f0f0f0' }}>
            <Button 
              onClick={() => setDeleteConfirmOpen(false)}
              variant="outlined"
              sx={{ borderRadius: '8px', textTransform: 'none' }}
            >
              Cancel
            </Button>
            <Button 
              type="submit"
              variant="contained" 
              color="error"
              sx={{ 
                borderRadius: '8px', 
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(211, 47, 47, 0.3)'
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Rejection Reason Dialog */}
      <Dialog 
        open={rejectDialogOpen} 
        onClose={() => setRejectDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
          }
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          fontSize: '1.5rem', 
          fontWeight: 600,
          borderBottom: '1px solid #f0f0f0',
          pb: 2,
          color: '#d32f2f'
        }}>
          Provide Rejection Reason
        </DialogTitle>
        <form onSubmit={(e) => {
          e.preventDefault();
          handleRejectConfirm();
        }}>
          <DialogContent sx={{ pt: 3 }}>
            <TextField
              autoFocus
              label="Rejection Reason"
              fullWidth
              variant="outlined"
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
              multiline
              rows={3}
              placeholder="Please provide a reason for rejecting this invoice"
            />
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #f0f0f0' }}>
            <Button 
              onClick={() => setRejectDialogOpen(false)}
              variant="outlined"
              sx={{ borderRadius: '8px', textTransform: 'none' }}
            >
              Cancel
            </Button>
            <Button 
              type="submit"
              variant="contained" 
              color="error"
              sx={{ 
                borderRadius: '8px', 
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(211, 47, 47, 0.3)'
              }}
            >
              Reject Invoice
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* CSV Upload Result Dialog */}
      <Dialog 
        open={csvResultOpen} 
        onClose={() => setCsvResultOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
          }
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          fontSize: '1.5rem', 
          fontWeight: 600,
          borderBottom: '1px solid #f0f0f0',
          pb: 2
        }}>
          CSV Upload Results
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
            <UploadIcon sx={{ color: 'primary.main', mr: 1 }} />
            <Typography variant="h6">
              Tasks created: {csvUploadResult?.tasks_created || 0}
            </Typography>
          </Box>
          
          {csvUploadResult?.errors && csvUploadResult.errors.length > 0 && (
            <Paper 
              variant="outlined" 
              sx={{ 
                p: 2, 
                mt: 2, 
                bgcolor: 'rgba(211, 47, 47, 0.05)', 
                borderColor: 'error.light',
                borderRadius: '8px'
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'error.main', mb: 1 }}>
                Errors:
              </Typography>
              <List dense disablePadding>
                {csvUploadResult.errors.map((error, index) => (
                  <ListItem key={index} sx={{ py: 0.5 }}>
                    <Typography color="error">{error}</Typography>
                  </ListItem>
                ))}
              </List>
            </Paper>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #f0f0f0' }}>
          <Button 
            onClick={() => setCsvResultOpen(false)}
            variant="contained"
            sx={{ borderRadius: '8px', textTransform: 'none' }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Task Confirmation Dialog */}
      <Dialog 
        open={deleteTaskConfirmOpen} 
        onClose={() => setDeleteTaskConfirmOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
          }
        }}
        maxWidth="sm"
      >
        <DialogTitle sx={{ 
          fontSize: '1.5rem', 
          fontWeight: 600,
          borderBottom: '1px solid #f0f0f0',
          pb: 2,
          color: '#d32f2f'
        }}>
          Confirm Delete Task
        </DialogTitle>
        <form onSubmit={(e) => {
          e.preventDefault();
          handleDeleteTaskConfirm();
        }}>
          <DialogContent sx={{ pt: 3 }}>
            <Typography variant="body1">
              Are you sure you want to delete the task for <strong>{todoToDelete?.supplier_name}</strong> ({todoToDelete?.month_year})?
            </Typography>
            {todoToDelete?.file_key && (
              <Typography variant="body2" color="error.main" sx={{ mt: 2 }}>
                Warning: This task has an uploaded invoice that will also be removed.
              </Typography>
            )}
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              This action cannot be undone.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #f0f0f0' }}>
            <Button 
              onClick={() => setDeleteTaskConfirmOpen(false)}
              variant="outlined"
              sx={{ borderRadius: '8px', textTransform: 'none' }}
            >
              Cancel
            </Button>
            <Button 
              type="submit"
              variant="contained" 
              color="error"
              sx={{ 
                borderRadius: '8px', 
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(211, 47, 47, 0.3)'
              }}
            >
              Delete Task
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Add Task Dialog */}
      <Dialog 
        open={addTaskOpen} 
        onClose={() => setAddTaskOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
          }
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          fontSize: '1.5rem', 
          fontWeight: 600,
          borderBottom: '1px solid #f0f0f0',
          pb: 2
        }}>
          Add New Task
        </DialogTitle>
        <form onSubmit={(e) => {
          e.preventDefault();
          handleAddTask();
        }}>
          <DialogContent sx={{ pt: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Date"
                  value={taskDate}
                  onChange={handleDateChange}
                  renderInput={(params) => <TextField {...params} fullWidth margin="dense" />}
                />
              </LocalizationProvider>
              <FormControl fullWidth margin="dense">
                <InputLabel id="supplier-select-label">Supplier</InputLabel>
                <Select
                  labelId="supplier-select-label"
                  id="supplier-select"
                  value={newTask.supplier_name}
                  label="Supplier"
                  onChange={(e) => setNewTask({...newTask, supplier_name: e.target.value})}
                >
                  {suppliers.map((supplier) => (
                    <MenuItem key={supplier.name} value={supplier.name}>
                      {supplier.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Title"
                fullWidth
                variant="outlined"
                margin="dense"
                value={newTask.title}
                onChange={(e) => setNewTask({...newTask, title: e.target.value})}
              />
              <TextField
                label="Description"
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                margin="dense"
                value={newTask.description}
                onChange={(e) => setNewTask({...newTask, description: e.target.value})}
              />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="Original Amount"
                  type="number"
                  value={newTask.originalAmount || ''}
                  onChange={(e) => {
                    const originalAmount = parseFloat(e.target.value) || 0;
                    const deduction = parseFloat(newTask.deduction || 0);
                    const finalAmount = originalAmount - deduction;
                    setNewTask({
                      ...newTask,
                      originalAmount: e.target.value,
                      amount: finalAmount.toFixed(2) // This is for display only, not sent to backend
                    });
                  }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                />
                <TextField
                  label="Deduction"
                  type="number"
                  value={newTask.deduction || ''}
                  onChange={(e) => {
                    const deduction = parseFloat(e.target.value) || 0;
                    const originalAmount = parseFloat(newTask.originalAmount || 0);
                    const finalAmount = originalAmount - deduction;
                    setNewTask({
                      ...newTask,
                      deduction: e.target.value,
                      amount: finalAmount.toFixed(2) // This is for display only, not sent to backend
                    });
                  }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                />
                <TextField
                  label="Final Amount"
                  type="number"
                  value={newTask.amount || ''}
                  disabled
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #f0f0f0' }}>
            <Button 
              onClick={() => setAddTaskOpen(false)}
              variant="outlined"
              sx={{ borderRadius: '8px', textTransform: 'none' }}
            >
              Cancel
            </Button>
            <Button 
              type="submit"
              variant="contained"
              disabled={isViewer || !newTask.supplier_name || !newTask.title || !newTask.month_year}
              sx={{ 
                borderRadius: '8px', 
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
              }}
            >
              Add Task
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Edit Task Dialog */}
      <Dialog 
        open={editTaskOpen} 
        onClose={() => {
          setEditTaskOpen(false);
          setTaskToEdit(null);
        }} 
        fullWidth 
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
          }
        }}
      >
        <DialogTitle sx={{ 
          fontSize: '1.5rem', 
          fontWeight: 600,
          borderBottom: '1px solid #f0f0f0',
          pb: 2
        }}>
          Edit Task
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth margin="dense">
                <InputLabel>Supplier</InputLabel>
                <Select
                  value={taskToEdit?.supplier_name || ''}
                  onChange={(e) => setTaskToEdit({...taskToEdit, supplier_name: e.target.value})}
                  label="Supplier"
                >
                  {suppliers.map(sup => (
                    <MenuItem key={sup.name} value={sup.name}>{sup.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Title"
                value={taskToEdit?.title || ''}
                onChange={(e) => setTaskToEdit({...taskToEdit, title: e.target.value})}
                fullWidth
                variant="outlined"
                margin="dense"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Month/Year"
                value={taskToEdit?.month_year || ''}
                onChange={(e) => setTaskToEdit({...taskToEdit, month_year: e.target.value})}
                fullWidth
                variant="outlined"
                margin="dense"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                value={taskToEdit?.description || ''}
                onChange={(e) => setTaskToEdit({...taskToEdit, description: e.target.value})}
                fullWidth
                multiline
                rows={2}
                variant="outlined"
                margin="dense"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Original Amount"
                type="number"
                value={taskToEdit?.originalAmount || ''}
                onChange={(e) => {
                  if (!taskToEdit) return;
                  const originalAmount = parseFloat(e.target.value) || 0;
                  const deduction = parseFloat(taskToEdit?.deduction || 0);
                  const finalAmount = originalAmount - deduction;
                  setTaskToEdit({
                    ...taskToEdit, 
                    originalAmount: originalAmount,
                    amount: finalAmount.toFixed(2) // This is for display only, not sent to backend
                  });
                }}
                fullWidth
                variant="outlined"
                margin="dense"
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Deduction"
                type="number"
                value={taskToEdit?.deduction || ''}
                onChange={(e) => {
                  if (!taskToEdit) return;
                  const newDeduction = parseFloat(e.target.value) || 0;
                  const originalAmount = parseFloat(taskToEdit?.originalAmount || 0);
                  const finalAmount = originalAmount - newDeduction;
                  
                  setTaskToEdit({
                    ...taskToEdit, 
                    deduction: newDeduction,
                    amount: finalAmount.toFixed(2) // This is for display only, not sent to backend
                  });
                }}
                fullWidth
                variant="outlined"
                margin="dense"
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Final Amount"
                type="number"
                value={taskToEdit?.amount !== null && taskToEdit?.amount !== undefined ? taskToEdit.amount : '0.00'}
                disabled
                fullWidth
                variant="outlined"
                margin="dense"
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth margin="dense">
                <InputLabel>Status</InputLabel>
                <Select
                  value={taskToEdit?.status || ''}
                  label="Status"
                  onChange={(e) => setTaskToEdit({...taskToEdit, status: e.target.value})}
                >
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="uploaded">Uploaded</MenuItem>
                  <MenuItem value="approved">Approved</MenuItem>
                  <MenuItem value="hold">On Hold</MenuItem>
                  <MenuItem value="rejected">Rejected</MenuItem>
                  <MenuItem value="paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {taskToEdit?.status === 'rejected' && (
              <Grid item xs={12}>
                <TextField
                  label="Rejection Reason"
                  value={taskToEdit?.rejection_reason || ''}
                  onChange={(e) => setTaskToEdit({...taskToEdit, rejection_reason: e.target.value})}
                  fullWidth
                  multiline
                  rows={2}
                  variant="outlined"
                  margin="dense"
                  required
                />
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={taskToEdit?.completed || false}
                    onChange={(e) => setTaskToEdit({...taskToEdit, completed: e.target.checked})}
                    color="primary"
                  />
                }
                label="Mark as Completed"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Due Date"
                  value={taskToEdit?.due_date ? new Date(taskToEdit.due_date) : null}
                  onChange={(newDate) => setTaskToEdit({...taskToEdit, due_date: newDate})}
                  renderInput={(params) => <TextField {...params} fullWidth margin="dense" />}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #f0f0f0' }}>
          <Button 
            onClick={() => {
              setEditTaskOpen(false);
              setTaskToEdit(null);
            }}
            variant="outlined"
            sx={{ borderRadius: '8px', textTransform: 'none' }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleEditTaskSubmit} 
            variant="contained" 
            color="primary"
            sx={{ 
              borderRadius: '8px', 
              textTransform: 'none',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
            }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Batch Supplier Upload Dialog */}
      <BatchSupplierUpload
        open={batchUploadOpen}
        onClose={() => setBatchUploadOpen(false)}
        onSuccess={() => {
          fetchSuppliers();
          setSnackbar({ open: true, message: 'Suppliers uploaded successfully', severity: 'success' });
        }}
      />

      {/* Batch Todo Upload Dialog */}
      <BatchTodoUpload
        open={batchTodoOpen}
        onClose={() => setBatchTodoOpen(false)}
        onSuccess={() => {
          fetchTodos();
          setSnackbar({ open: true, message: 'Tasks uploaded successfully', severity: 'success' });
        }}
      />

      {/* Snackbar for notifications */}
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={6000} 
        onClose={() => setSnackbar({...snackbar, open: false})}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity={snackbar.severity} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Drawer anchor="right" open={auditDrawerOpen} onClose={handleCloseAuditDrawer}>
        <Box sx={{ width: 400, p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Audit Log
          </Typography>
          {auditLoading ? (
            <CircularProgress />
          ) : auditLogs.length === 0 ? (
            <Typography>No audit logs found.</Typography>
          ) : (
            <Stepper orientation="vertical" nonLinear activeStep={-1}>
              {auditLogs.map((log, idx) => (
                <Step key={log.id} completed>
                  <StepLabel>{`${log.action} by ${log.performed_by} at ${new Date(log.performed_at).toLocaleString()} Filename: ${log.details.file_name}`}</StepLabel>
                </Step>
              ))}
            </Stepper>
          )}
          <Button onClick={handleCloseAuditDrawer} sx={{ mt: 2 }} fullWidth variant="outlined">Close</Button>
        </Box>
      </Drawer>

      {/* Approve Dialog for selecting expected payment date */}
      <Dialog 
        open={approveDialogOpen} 
        onClose={() => setApproveDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Approve Invoice</DialogTitle>
        <DialogContent>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Expected Payment Date"
              value={approveDate}
              onChange={setApproveDate}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setApproveDialogOpen(false)}>
            Cancel
          </Button>
          <Button 
            onClick={async () => {
              if (!approveDate) return;
              const [month, year] = approveTodo.month_year.split('/');
              const paddedMonth = month.padStart(2, '0');
              const normalizedMonthYear = `${paddedMonth}-${year}`;
              await updateTodoAdmin(approveTodo.supplier_name, normalizedMonthYear, {
                status: 'approved',
                expected_payment_date: approveDate,
              });
              setApproveDialogOpen(false);
              setApproveTodo(null);
              setApproveDate(null);
              fetchTodos();
              setSnackbar({ open: true, message: 'Invoice approved successfully', severity: 'success' });
            }}
            disabled={!approveDate}
            variant="contained"
            color="success"
          >
            Approve
          </Button>
        </DialogActions>
      </Dialog>

      {/* Ping Dialog */}
      <Dialog open={pingDialogOpen} onClose={handleClosePingDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Send Reminder (Ping)</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            Send a reminder email to <b>{pingTodo?.user_email}</b> for this todo.
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={3}
            label="Message"
            value={pingMessage}
            onChange={e => setPingMessage(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePingDialog}>Cancel</Button>
          <Button onClick={handleSendPing} variant="contained" color="primary">
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminDashboard; 